var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/json/index.ts
import jsonParse from "parse-json";
import { configure, stringify as stableStringify } from "safe-stable-stringify";
var stringifyNonDeterministic = configure({ deterministic: false });
var stringifyDeterministic = stableStringify;
function stringify(value, replacerOrOptions, space, fallback) {
  try {
    if (replacerOrOptions && typeof replacerOrOptions === "object" && !Array.isArray(
    replacerOrOptions) && typeof replacerOrOptions !== "function") {
      const options = replacerOrOptions;
      const result2 = stringifyNonDeterministic(value);
      return typeof result2 === "string" ? result2 : options.fallback ?? "";
    }
    const result = stringifyNonDeterministic(
      value,
      replacerOrOptions,
      space
    );
    return typeof result === "string" ? result : fallback ?? "";
  } catch {
    return typeof replacerOrOptions === "object" && !Array.isArray(replacerOrOptions) &&
    typeof replacerOrOptions !== "function" ? replacerOrOptions.fallback ?? "" :
    fallback ?? "";
  }
}
__name(stringify, "stringify");
function parse(str, fallback) {
  try {
    return jsonParse(str);
  } catch {
    return fallback ?? null;
  }
}
__name(parse, "parse");
export {
  parse,
  stringify,
  stringifyDeterministic
};
